<script context="module">
  export function youtube_parser(url) {
    var regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#&?]*).*/
    var match = url.match(regExp)
    return match && match[7].length == 11 ? match[7] : false
  }

  export function flip(order, flip) {
    if (order == '1') {
      if (flip) {
        return 'order-2'
      } else {
        return 'order-1'
      }
    } else {
      if (flip) {
        return 'order-1'
      } else {
        return 'order-2'
      }
    }
  }
</script>
